import { SvgIcon } from '@cinch-labs/design-system'
import styles from './store-details-list.module.css'
import { IconNames } from '@cinch-labs/design-system/dist/src/tokens/tokens.types'

export interface StoreDetailsListProps {
  icon: keyof typeof IconNames
  title: string
  children: React.ReactNode
}
export const StoreDetailsList = ({
  icon,
  title,
  children,
}: StoreDetailsListProps) => (
  <section className={styles.storeDetailsSection}>
    <SvgIcon name={icon} size={20} className={styles.svg} />
    <div className={styles.storeDetails}>
      <h3 className={styles.storeDetailsTitle}>{title}</h3>
      <div className={styles.storeDetailsContent}>{children}</div>
    </div>
  </section>
)
